import { PIE_CHART_OTHERS_COLOR, PIE_CHART_SLICE_COLORS } from '@/pages/ui/pie-chart/constants'
import type { PieChartSliceData } from '@/pages/ui/pie-chart/types'

import { cn } from '@/lib/utils'

interface Props {
  data: PieChartSliceData[]
}

export const CaseTypeBreakdownLegend: React.FC<Props> = ({ data }) => {
  const nCols = Math.min(4, data.length)
  const nColItems = Math.ceil(data.length / nCols)
  const cols = Array(nCols).fill([]) as PieChartSliceData[][]

  for (let i = 0; i < nCols; i++) {
    cols[i] = data.slice(i * nColItems, (i + 1) * nColItems)
  }

  return (
    <div className={cn('flex justify-center gap-x-8 gap-y-1.5')}>
      {cols.map((col, i) => {
        return (
          <div key={i} className="flex flex-col gap-y-1.5">
            {col.map((x, j) => {
              const color = x.others
                ? PIE_CHART_OTHERS_COLOR
                : PIE_CHART_SLICE_COLORS[(i * col.length + j) % PIE_CHART_SLICE_COLORS.length]

              return (
                <div key={j} className="flex items-center justify-between gap-6">
                  <div className={cn('flex items-center')}>
                    <div className={cn('mr-[6px] size-[12px] rounded-full')} style={{ backgroundColor: color }} />
                    <div className={cn('mr-[9px] text-[14px] leading-[22px] text-[#555555]')}>{x.name}</div>
                    <div className={cn('text-[12px] leading-[18px] text-[#999999]')}>
                      {(x.ratio * 100).toFixed(2).replace(/\.?0+$/, '')}%
                    </div>
                  </div>
                  <div className={cn('text-[12px] font-[500] leading-[18px] text-slate-500')}>
                    {x.value.toLocaleString()}
                  </div>
                </div>
              )
            })}
          </div>
        )
      })}
    </div>
  )
}
